import { useMemo } from 'react';

/**
 * Utils
 */
import { DESKTOP } from '@/src/utils/device/devices';
import useDeviceType from '@/src/hooks/useDeviceType';

function useIsDesktopLayout() {
  const device = useDeviceType();
  const isDesktop = useMemo(() => device === DESKTOP, [device]);
  return isDesktop;
}
export default useIsDesktopLayout;
